import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import useFetch from 'use-http'

import Layout from "./layout";

export default function Logout(props) {
    let history = useHistory();
    const fetchOptions = { cachePolicy: 'no-cache' }
    const { post } = useFetch(`${process.env.REACT_APP_LOCAL_SERVER}/php/onlinebooking`, fetchOptions)

    useEffect(() => {
        async function doLogOut() {
            const logoutResult = await post('/logout.php', { login_code: localStorage.getItem("login_code") })
            //console.log(logoutResult);

            localStorage.clear();
            history.push(`/`);
        }

        doLogOut();
    }, [history, post])

    return (
        <Layout>
            <span>You have been logged out.</span>
        </Layout>
    )
}